
export const environment = {
  production: false,
  commonPaymentApiBasePath : 'https://qa.paybyphone.cinchhs.com/commonPayment/',
  ivrCallTransfer: 'https://apis.qa.accelerate.cinchhs.com/paymentsvc/api/callmonitor/',
  originalPaymentUIDomain: 'https://qa.payment.cinchhs.com/'
};
